<script setup lang="ts">
import { TELEGRAM_CHANNEL_LINK } from '~/shared/lib/socials';

const isTelegramBlockVisible = useCookie<boolean>('isTelegramBlockVisible', {
  default: () => true,
  watch: true,
  maxAge: undefined,
});

const hideTelegramBlock = () => {
  isTelegramBlockVisible.value = false;
};
</script>

<template>
  <NuxtLink
    v-if="isTelegramBlockVisible"
    :class="$style.telegram"
    external
    :to="TELEGRAM_CHANNEL_LINK"
    target="_blank"
  >
    <div :class="$style.telegram__title">CRE в Telegram</div>
    <Icon
      :class="$style.telegram__icon"
      size="24"
      name="my-icon:i-close"
      @click.prevent="hideTelegramBlock"
    />
  </NuxtLink>
</template>

<style module lang="scss">
.telegram {
  display: flex;
  height: 42px;
  align-items: center;
  justify-content: space-between;
  background:
    url(./images/cloud.svg) no-repeat right 38px center,
    url(./images/tg.png) no-repeat right 79px center #2aabee;
  padding-left: 15px;
  padding-right: 15px;
  text-decoration: none;

  &__title {
    @include text_body1_medium;
    color: var(--color-white);
  }

  &__icon {
    path {
      fill: var(--color-white);
    }
  }
}
</style>
